import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/upload',
    name: 'Upload',
    component: () => import(/* webpackChunkName: "upload" */ '../views/UploadView.vue')
  },
  {
    path: '/transects',
    name: 'TransectsView',
    component: () => import(/* webpackChunkName: "TransectVCardsView" */ '../views/TransectsView.vue')
  },
  {
    path: '/transects/:transectCode',
    name: 'TransectView',
    component: () => import(/* webpackChunkName: "TransectView" */ '../views/TransectView.vue')
  },
  {
    path: '/incorrectlyPictures',
    name: 'IncorrectlyPictures',
    component: () => import(/* webpackChunkName: "incorrectlyPictures" */ '../views/IncorrectPicturesView.vue')
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import(/* webpackChunkName: "settings" */ '../views/SettingsView.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "settings" */ '@/views/LoginView.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
